import React from "react";
import {
  Box,
  Card,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

const headerSx = {
  backgroundColor: "#fafbfc",
  color: "#8896ab",
  fontWeight: 600,
  fontSize: "0.6rem",
  padding: "10px 10px",
  borderBottom: "1px solid #edf0f4",
  letterSpacing: "0.6px",
  textTransform: "uppercase",
  whiteSpace: "nowrap",
};

const cellSx = {
  padding: "11px 10px",
  borderBottom: "1px solid #f4f6f8",
};

const CriticalStockTable = ({ data, getSemanasColor }) => {
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: "18px",
        border: "1px solid rgba(0,0,0,0.04)",
        overflow: "hidden",
        backgroundColor: "#fff",
        boxShadow: "0 1px 3px rgba(0,0,0,0.02), 0 6px 16px rgba(0,0,0,0.02)",
        width: "100%",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box sx={{ padding: "18px 22px 10px", flexShrink: 0 }}>
        <Typography sx={{ fontSize: "0.82rem", fontWeight: 700, color: "#0f172a", letterSpacing: "-0.01em" }}>
          Stock Crítico
        </Typography>
        <Typography sx={{ fontSize: "0.65rem", color: "#94a3b8", mt: 0.2 }}>
          Productos con riesgo de quiebre
        </Typography>
      </Box>

      <TableContainer sx={{ flex: 1, overflow: "auto" }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell align="left" sx={headerSx}>SKU</TableCell>
              <TableCell align="center" sx={headerSx}>P. Ing.</TableCell>
              <TableCell align="center" sx={headerSx}>Stock</TableCell>
              <TableCell align="center" sx={headerSx}>P. Egr.</TableCell>
              <TableCell align="center" sx={headerSx}>Rank</TableCell>
              <TableCell align="center" sx={headerSx}>Días</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(!data || data.length === 0) && (
              <TableRow>
                <TableCell colSpan={6} sx={{ ...cellSx, borderBottom: "none", textAlign: "center", py: 5 }}>
                  <Typography sx={{ fontSize: "0.78rem", fontWeight: 600, color: "#64748b" }}>
                    Sin productos para mostrar
                  </Typography>
                  <Typography sx={{ fontSize: "0.68rem", color: "#94a3b8", mt: 0.3 }}>
                    Cargá productos y movimientos para ver el ranking.
                  </Typography>
                </TableCell>
              </TableRow>
            )}
            {(data || []).map((row, index) => {
              const tieneDias = row.semanas > 0;
              const semanasColor = getSemanasColor(row.semanas);
              return (
                <TableRow
                  key={row.sku}
                  sx={{
                    transition: "background-color 0.15s ease",
                    "&:hover": { backgroundColor: "#f8fafd" },
                    "&:last-child td": { borderBottom: "none" },
                  }}
                >
                  <TableCell align="left" sx={cellSx}>
                    <Typography
                      sx={{
                        fontWeight: 700,
                        color: "#1e293b",
                        fontSize: "0.72rem",
                        fontFamily: "'SF Mono', 'Roboto Mono', monospace",
                        letterSpacing: "0.02em",
                      }}
                    >
                      {row.sku}
                    </Typography>
                  </TableCell>
                  <TableCell align="center" sx={cellSx}>
                    <Typography sx={{ color: "#8896ab", fontSize: "0.78rem", fontWeight: 500 }}>
                      {row.pendienteIngreso}
                    </Typography>
                  </TableCell>
                  <TableCell align="center" sx={cellSx}>
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: "0.82rem",
                        color: row.stock <= 3 ? "#ef4444" : "#0f172a",
                      }}
                    >
                      {row.stock}
                    </Typography>
                  </TableCell>
                  <TableCell align="center" sx={cellSx}>
                    <Typography sx={{ color: "#8896ab", fontSize: "0.78rem", fontWeight: 500 }}>
                      {row.pendienteEgreso}
                    </Typography>
                  </TableCell>
                  <TableCell align="center" sx={cellSx}>
                    <Typography sx={{ color: "#8896ab", fontSize: "0.78rem", fontWeight: 500 }}>
                      {row.ranking}
                    </Typography>
                  </TableCell>
                  <TableCell align="center" sx={cellSx}>
                    {tieneDias ? (
                      <Box
                        sx={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          minWidth: "42px",
                          padding: "3px 10px",
                          borderRadius: "8px",
                          backgroundColor: `${semanasColor}12`,
                          border: `1px solid ${semanasColor}25`,
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "0.7rem",
                            fontWeight: 700,
                            color: semanasColor,
                            lineHeight: 1,
                          }}
                        >
                          {row.semanas}
                        </Typography>
                      </Box>
                    ) : (
                      <Typography sx={{ color: "#cbd5e1", fontSize: "0.78rem", fontWeight: 500 }}>—</Typography>
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
};

export default CriticalStockTable;
